/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Keycloak configuration model
 *
 * Describes the build-time Keycloak client settings declared by environments
 * that support the Keycloak authentication provider.
 */

/**
 * Keycloak client settings passed to the Keycloak JavaScript adapter.
 *
 * Only the fields understood by `keycloak-js` belong here; redirect targets are
 * derived from the current browser origin at runtime.
 */
export interface IKeycloakConfiguration {
  /** Base URL of the Keycloak server, for example `https://keycloak.example.com`. */
  readonly url: string;

  /** Name of the Keycloak realm that issues the application tokens. */
  readonly realm: string;

  /** Public OIDC client identifier registered for the web application. */
  readonly clientId: string;
}

/**
 * Keycloak setting of environments that do not offer Keycloak and use Auth0.
 *
 * Environments reference this constant instead of a local annotated
 * `undefined`, because TypeScript narrows a locally initialized constant to
 * the literal `undefined` type, which would make `environment.keycloak`
 * non-assignable in specs that switch the provider configuration.
 */
export const KEYCLOAK_NOT_CONFIGURED: IKeycloakConfiguration | undefined =
  undefined;
